// NEW STYPEPARAMS METHOD
var ITEM_RESOLUTION_MODE = {
    FULL: 'FULL',
    SCALED_DOWN: 'SCALED_DOWN',
};
export default ITEM_RESOLUTION_MODE;
//# sourceMappingURL=stylingParams_itemResolutionMode.js.map